export default __webpack_public_path__ + "static/media/Mallorie_Dunn_AHV_In_Moms_We_Trust.46da07a8.jpg";